module.exports = __webpack_public_path__ + "img/Tanner.76766afc.png";